export function decodeBase64ToUtf8(base64String: string) {
  const binaryString = atob(base64String);
  const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
}
